// Toaster Notification Constants
export const TOP_RIGHT = "top-right";
export const BOTTOM_RIGHT = "bottom-right";
export const ERROR = "Error";
export const SUCCESS = "Success";
export const REFUND_DESCRIPTION = `refundable $TYPE of $AMOUNT - returnable to the CLIENT up to $TIME after the event has been held, once property has been inspected for any possible damage from special event.`;
